'use client'

import { setUserPreferences } from '@/lib/api/user-preferences/user-preferences.actions'
import {
  FULL_NAME_KEY,
  THEME_PRIMARY_COLOR_KEY,
  THEME_SCHEME_KEY,
} from '@/lib/api/user-preferences/user-preferences.constants'
import { UserPreferenceValue } from '@/lib/api/user-preferences/user-preferences.types'

/**
 * Persisting is a round trip now, so writes for a key are queued: without it
 * two quick theme changes could land out of order and store the stale one.
 */
export const createPreferenceWriter = (key: string) => {
  let queue: Promise<unknown> = Promise.resolve()

  return (value: UserPreferenceValue) => {
    queue = queue
      .then(() => setUserPreferences(key, value))
      .catch((error: unknown) => {
        console.error(`Unable to persist "${key}"`, error)
      })
  }
}

export const persistPrimaryColor = createPreferenceWriter(THEME_PRIMARY_COLOR_KEY)
export const persistColorScheme = createPreferenceWriter(THEME_SCHEME_KEY)
export const persistFullName = createPreferenceWriter(FULL_NAME_KEY)
